/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  // onFormSubmit(event) {
  //   if (!this.getQuery().length) {
  //     event.preventDefault();
  //   }
  // }

  onFormSubmit(event) {
  if (!this.getQuery().length) {
    event.preventDefault();
  } else {
    // Add type=product to the form submission
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'type';
    input.value = 'product';
    this.form.appendChild(input);
  }
}

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  // getSearchResults(searchTerm) {
  //   const queryKey = searchTerm.replace(" ", "-").toLowerCase();

  //   this.predictiveSearchResults.classList.add('loading');

  //   fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
  //     .then((response) => {
  //       this.predictiveSearchResults.classList.remove('loading');
  //       if (!response.ok) {
  //         var error = new Error(response.status);
  //         throw error;
  //       }

  //       return response.text();
  //     })
  //     .then((text) => {
  //       const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

  //       this.renderSearchResults(resultsMarkup);
  //     })
  //     .catch((error) => {
  //       throw error;
  //     });
  // }

  getSearchResults(searchTerm) {
  const queryKey = searchTerm.replace(" ", "-").toLowerCase();

  this.predictiveSearchResults.classList.add('loading');

  // Add &type=product to the URL
  fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&type=product&section_id=predictive-search`)
    .then((response) => {
      this.predictiveSearchResults.classList.remove('loading');
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

      this.renderSearchResults(resultsMarkup);
    })
    .catch((error) => {
      throw error;
    });
}

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');


    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});